module.exports = __webpack_public_path__ + "static/img/victim-kids-5.ebfcc37e.png";